import type {Pointer} from '@wix/document-services-types'
import type {CreateExtArgs} from '@wix/document-manager-core'
import type {RoutersExtensionAPI} from '../../../routers'
import _ from 'lodash'

export function beforePageRemoveHook(createExtArgs: CreateExtArgs, pagePointer: Pointer): void {
    const {extensionAPI, pointers, eventEmitter, EVENTS} = createExtArgs
    const {routers} = extensionAPI as RoutersExtensionAPI

    const allRouters = routers.getAllRouters()
    const pageId = pagePointer.id
    const routerId = _.findKey(allRouters, router => router.pages && _.includes(_.values(router.pages), pageId))

    if (routerId) {
        const routerPtr = pointers.routers.getRouterPointer(routerId)
        const routerData = allRouters[routerId]
        const pageRole = _.findKey(routerData.pages, pid => pid === pageId)
        eventEmitter.emit(EVENTS.ROUTERS.ROUTER_PAGE_DELETED, routerData.appDefinitionId, {pageRole})
        routers.pages.remove(routerPtr, pageId)
    }
}
